import api from './api';

export interface InwardImportRowResult {
  rowIndex: number;
  status: 'success' | 'failed';
  grnNumber?: string;
  reason?: string;
}

export interface InwardImportSummary {
  totalRows: number;
  succeeded: number;
  failed: number;
  results: InwardImportRowResult[];
}

export const inwardImportService = {
  importExcel: async (file: File): Promise<InwardImportSummary> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/inward-import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    });

    const responseData = response as any;
    return responseData.data as InwardImportSummary;
  },
};
